import { combineReducers } from 'redux';
import { Requests } from './Request/redux/reducers';
import { Orders } from './Order/redux/reducers';
import { Offers } from "./Offer/redux/reducers";

export const Executorship = combineReducers({
	Requests,
	Offers,
	Orders
});
